import React, { useEffect, useState } from "react";
import {
  viewResumeUrl,
  GetCandidateDetails,
  HoldCandidates,
  StartBGV,
  SendAssessmentCandidate,
  SystemRemark,
  GetCandidateInterviewDetails,
  IsInterviewScheduled,
  GetInterviewFeedbackByUID,
  ScheduleNextInterview,
} from "../../CandidateServices/CandidateService";
import { GetAllRejectedCandidates } from "../Services/RejectedCandidateService";

import { Funnel, MoreVertical, FileText } from "lucide-react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import ColumnFilterModal from "../../../CommonModals/ColumnFilterModal";
import Pagination from "../../../CommonModals/Pagination";
import CandidateDetailsModal from "../../NewApplications/Modal/CandidateDetailsModal";
import ViewResumeModal from "../../../Jobs/SendCandidates/Modals/ViewResumeModal";
import NormalAlert from "../../../../Alerts/NormalAlert";
import ScheduleInterviewModal from "../../InterviewScheduled/Modal/ScheduleInterviewModal";
import InterviewFeedbackModal from "../../InterviewScheduled/Modal/InterviewFeedbackModal";
import SystemRemarkModal from "../../NewApplications/Modal/SystemRemarkModal";

const RejectedCandidates = () => {
  const [loading, setLoading] = useState(true);
  const [candidates, setCandidates] = useState([]);

  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [candidateDetails, setCandidateDetails] = useState(null);

  //Interviwer Details State
  const [interviewDetails, setInterviewDetails] = useState([]);
  const [isInterviewScheduled, setIsInterviewScheduled] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [selectedInterview, setSelectedInterview] = useState(null);
  const [interviewDateTime, setInterviewDateTime] = useState("");
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedbackData, setFeedbackData] = useState(null);

  const [modalType, setModalType] = useState(null);
  const [remark, setRemark] = useState("");
  const [assessmentLink, setAssessmentLink] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [resumeUrl, setResumeUrl] = useState("");

  const [alert, setAlert] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [openMenu, setOpenMenu] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [showSystemRemark, setShowSystemRemark] = useState(false);
  const [systemRemarkData, setSystemRemarkData] = useState(null);
  const [showSystemRemarkModal, setShowSystemRemarkModal] = useState(false);
  const [systemRemarkLoading, setSystemRemarkLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  //  FILTER STATE (Added Same as Shortlisted)
  const [activeFilter, setActiveFilter] = useState(null);
  const [filterSearch, setFilterSearch] = useState("");
  const [filters, setFilters] = useState({
      jobTitel: [],
      submitByType: [],
      functionName: [],
      department: [],
      grade: [],
    });
  
    const filterOptions = {
      jobTitel: [...new Set(candidates.map((c) => c.jobTitel))],
      submitByType: [...new Set(candidates.map((c) => c.submitByType))],
      functionName: [...new Set(candidates.map((c) => c.functionName))],
      department: [...new Set(candidates.map((c) => c.department))],
      grade: [...new Set(candidates.map((c) => c.grade))],
    };
  
    const filteredCandidates = candidates.filter((candidate) => {
      const matchesJobTitle =
        (filters.jobTitel || []).length === 0 ||
        (filters.jobTitel || []).includes(candidate.jobTitel);
  
      const matchesSubmitType =
        (filters.submitByType || []).length === 0 ||
        (filters.submitByType || []).includes(candidate.submitByType);
  
      const matchesFunction =
        (filters.functionName || []).length === 0 ||
        (filters.functionName || []).includes(candidate.functionName);
  
      const matchesDepartment =
        (filters.department || []).length === 0 ||
        (filters.department || []).includes(candidate.department);
  
      const matchesGrade =
        (filters.grade || []).length === 0 ||
        (filters.grade || []).includes(candidate.grade);
  
      const matchesSearch = [
        candidate.jobTitel,
        candidate.submitByType,
        candidate.functionName,
        candidate.department,
        candidate.grade,
        candidate.name,
        candidate.email
      ].some((field) => field?.toLowerCase().includes(searchTerm.toLowerCase()));
  
      return (
        matchesJobTitle &&
        matchesSubmitType &&
        matchesFunction &&
        matchesDepartment &&
        matchesGrade &&
        matchesSearch
      );
    });
  
    useEffect(() => {
      setCurrentPage(1);
    }, [searchTerm, filters]);

  const GetRejectedCandidates = async () => {
    try {
      const response = await GetAllRejectedCandidates();

      if (
        response?.data?.status === "Success" &&
        response?.data?.rejectedCandidates
      ) {
        setCandidates(response.data.rejectedCandidates);
      } else {
        setAlert({
          type: "fail",
          message: response?.data?.message || "No rejected candidates found.",
        });
        setCandidates([]);
      }
    } catch (error) {
      const backendMessage = error?.response?.data?.message;

      if (backendMessage !== "No candidate found.") {
        setAlert({
          type: "fail",
          message: backendMessage || "Something went wrong. Please try again.",
        });
      }

      setCandidates([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      await GetRejectedCandidates();
      setLoading(false);
    };

    loadData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".action-menu")) {
        setOpenMenu(null);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filters]);

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentCandidates = filteredCandidates.slice(indexOfFirst, indexOfLast);

  //  View Details
  const handleNameClick = async (candidate) => {
    try {
      // Check interview scheduled or not
      const interviewStatus = await IsInterviewScheduled(
        candidate.submitedCandidateUID,
      );

      const isScheduled = interviewStatus?.status === "Success";
      setIsInterviewScheduled(isScheduled);

      //  Only fetch interview details if scheduled
      if (isScheduled) {
        const res = await GetCandidateInterviewDetails(
          candidate.submitedCandidateUID,
        );

        const data = res?.data || res;

        if (data?.interviewDetails?.status === "Success") {
          setCandidateDetails({
            candidateDetails: data.interviewDetails?.candidateDetails,
            jobDetails: data.interviewDetails?.jobDetails,
          });

          setInterviewDetails(data.interviewDetails?.jobInterviewers || []);

          setSelectedCandidate(data.interviewDetails?.candidateDetails);
        }
      } else {
        //  If not scheduled → fallback to normal details
        const res = await GetCandidateDetails(candidate.submitedCandidateUID);

        if (res?.data?.status === "Success") {
          setCandidateDetails(res.data);
          setInterviewDetails([]); // clear
          setSelectedCandidate(candidate);
        }
      }

      setShowModal(true);
    } catch (err) {
      console.error(err);
    }
  };

  //  Resume
  const handleResumeClick = async (candidate) => {
    if (!candidate?.resumePath) {
      setAlert({ type: "fail", message: "Resume not available" });
      return;
    }

    const fileName = candidate.resumePath.split("/").pop();
    const url = await viewResumeUrl(fileName);

    setResumeUrl(url);
    setShowModal(false);
    setShowResumeModal(true);
  };

  const handleViewSystemRemark = async () => {
    try {
      setSystemRemarkLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const response = await SystemRemark(
        selectedCandidate.submitedCandidateUID,
      );

      if (response?.data?.status === "Success") {
        setSystemRemarkData(response.data.data);
        setShowSystemRemarkModal(true);
      } else {
        setAlert({
          type: "fail",
          message: "Failed to fetch system remark",
        });
      }
    } catch (error) {
      setAlert({
        type: "fail",
        message: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setSystemRemarkLoading(false);
    }
  };

  //  Actions
  const handleAction = async () => {
    try {
      setActionLoading(true);

      let res;

      if (modalType === "BGV") {
        res = await StartBGV(
          selectedCandidate.submitedCandidateUID,
          11,
          remark,
        );
      }

      if (modalType === "Hold") {
        res = await HoldCandidates(
          selectedCandidate.submitedCandidateUID,
          8,
          remark,
        );
      }

      if (modalType === "Assessment") {
        res = await SendAssessmentCandidate(
          selectedCandidate.submitedCandidateUID,
          4,
          remark,
          assessmentLink,
        );
      }

      if (res?.data) {
        setAlert({
          type: res.data.status,
          message: res.data.message,
        });

        setShowModal(false);
        setModalType(null);
        setRemark("");
        await GetRejectedCandidates();
      }
    } catch {
      setAlert({ type: "fail", message: "Action failed" });
    } finally{
      setActionLoading(false)
    }
  };

  const handleScheduleClick = (interviewer) => {
    setSelectedInterview(interviewer);
    setShowModal(false);
    setShowScheduleModal(true);
  };

  const handleViewFeedback = async (interviewer) => {
    try {
      const res = await GetInterviewFeedbackByUID(
        selectedCandidate.submitedCandidateUID,
        interviewer.interviewUID,
      );

      if (res?.status === "Success" && res?.interviews?.length > 0) {
        setFeedbackData(res.interviews[0]);
      } else {
        setFeedbackData(null);
      }

      setShowDetailsModal(false);

      setTimeout(() => {
        setShowFeedbackModal(true);
      }, 100);
    } catch {
      setFeedbackData(null);
      setShowDetailsModal(false);
      setShowFeedbackModal(true);
    }
  };

  const formatDateTime = (dateTime) => {
    if (!dateTime) return null;
    const date = new Date(dateTime);

    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:00.000`;
  };

  const handleSchedule = async () => {
    try {
      const formattedDate = formatDateTime(interviewDateTime);

      const response = await ScheduleNextInterview(
        selectedInterview.interviewUID,
        formattedDate,
      );

      if (response.data.status === "Success") {
        setAlert({ type: "success", message: response.data.message });
        setShowScheduleModal(false);
      } else {
        setAlert({ type: "error", message: response.data.message });
      }
    } catch {
      setAlert({ type: "error", message: "Something went wrong" });
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";

    try {
      return dateStr.split("T")[0];
    } catch {
      return "";
    }
  };

  return (
    <>
      <div className="w-full py-8 mt-12">
        <div className="max-w-[1240px] mx-auto">
          <div className="bg-white rounded-2xl px-6 py-6 shadow-sm">
            {/* HEADER */}
            <div className="bg-master-header text-white rounded-xl px-3 py-2 mb-6">
              <h3 className="font-bold text-lg">Rejected Candidates</h3>
            </div>

            {/* SEARCH */}
            <div className="mb-6">
              <input
                type="text"
                placeholder="Search by name, title etc"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border border-gray-300 rounded-full px-5 py-2 w-full max-w-sm focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>

            {/* TABLE */}
            <div className="border rounded-lg overflow-visible">
              <table className="w-full">
                 <thead className="bg-[#f5f8ff] text-sm uppercase">
                                  <tr>
                                    <th className="py-3 text-left w-[5%]">#</th>
                
                                    <th className="py-3 text-left w-[20%]">Candidate Info</th>
                
                                    <th className="py-3 text-left w-[15%]">
                                      <div className="flex items-center gap-2">
                                        Submitted By
                                        <Funnel
                                          size={14}
                                          onClick={() => setActiveFilter("submitByType")}
                                          className="cursor-pointer text-primary"
                                        />
                                      </div>
                                    </th>

                                    <th className="py-3 text-left w-[20%]">
                                      <div className="flex items-center gap-2">
                                        Role Info
                                        <Funnel
                                          size={14}
                                          onClick={() => setActiveFilter("jobTitel")}
                                          className="cursor-pointer text-primary"
                                        />
                                      </div>
                                    </th>
                
                                    <th className="py-3 text-left w-[15%]">
                                      <div className="flex items-center gap-2">
                                        Function
                                        <Funnel
                                          size={14}
                                          onClick={() => setActiveFilter("functionName")}
                                          className="cursor-pointer text-primary"
                                        />
                                      </div>
                                    </th>
                                    <th className="py-3 text-left w-[15%]">
                                      <div className="flex items-center gap-2">
                                        Department
                                        <Funnel
                                          size={14}
                                          onClick={() => setActiveFilter("department")}
                                          className="cursor-pointer text-primary"
                                        />
                                      </div>
                                    </th>
                                    <th className="py-3 text-left w-[20%]">
                                      <div className="flex items-center gap-2">
                                        Grade
                                        <Funnel
                                          size={14}
                                          onClick={() => setActiveFilter("grade")}
                                          className="cursor-pointer text-primary"
                                        />
                                      </div>
                                    </th>
                
                                    <th className="py-3 text-center w-[10%]">Action</th>
                                  </tr>
                                </thead>

                <tbody>
                  {loading ? (
                    <SkeletonTheme>
                      {[...Array(5)].map((_, idx) => (
                        <tr key={idx} className="border-t">
                          {[...Array(7)].map((__, i) => (
                            <td key={i} className="py-4 px-3">
                              <Skeleton height={20} />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </SkeletonTheme>
                  ) : currentCandidates.length ? (
                    currentCandidates.map((candidate, idx) => (
                      <tr key={idx} className="border-t hover:bg-gray-50">
                         <td className="py-6">{indexOfFirst + idx + 1}</td>
                        {/* <td>{candidate.roleCode || "--"}</td> */}
                        <td className="cursor-pointer text-left">
                          <div className="flex flex-col items-start">
                            <span
                              className="text-blue-500 font-semibold"
                              onClick={() => handleNameClick(candidate)}
                            >
                              {candidate.name || "-"}
                            </span>

                            <span className="text-gray-600 text-sm">
                              {candidate.mobile || "-"}
                            </span>

                            <span className="text-gray-500 text-xs">
                              {candidate.email || "-"}
                            </span>
                          </div>
                        </td>

                        <td className="text-left">
                          <div className="flex flex-col items-start">
                            <span className="text-sm font-semibold">
                              {candidate.submitedBy}
                            </span>

                            <span className="text-gray-500 text-sm">
                              {candidate.submitByType}
                            </span>

                             <span className="text-gray-500 text-sm">
                              {formatDate(candidate.submitDate)}
                            </span>
                          </div>
                        </td>

                        <td className="text-left">
                          <div className="flex flex-col items-start">
                            <span className="text-sm font-semibold">
                              {candidate.roleCode || "-"}
                            </span>

                            <span className="text-gray-500 text-sm">
                              {candidate.jobTitel || "-"}
                            </span>
                          </div>
                        </td>
                        <td>{candidate.functionName}</td>
                        <td>{candidate.department}</td>
                        <td>{candidate.grade}</td>

                        <td className="text-center">
                          <div className="flex justify-center items-center gap-3 relative">
                            <button
                              onClick={() => handleResumeClick(candidate)}
                              className="p-1 hover:bg-gray-100 rounded-full"
                            >
                              <FileText size={18} className="text-blue-500" />
                            </button>

                            <div className="relative inline-block action-menu">
                              <button
                                onClick={() =>
                                  setOpenMenu(
                                    openMenu === candidate.submitedCandidateUID
                                      ? null
                                      : candidate.submitedCandidateUID,
                                  )
                                }
                                className="p-1 hover:bg-gray-100 rounded-full"
                              >
                                <MoreVertical size={18} />
                              </button>

                              {openMenu === candidate.submitedCandidateUID && (
                                <div className="absolute right-0 mt-2 w-48 bg-white border rounded-lg shadow-lg z-50">
                                  <button
                                    onClick={async () => {
                                      try {
                                        setOpenMenu(null);

                                        const res = await GetCandidateDetails(
                                          candidate.submitedCandidateUID,
                                        );

                                        if (res?.data?.status === "Success") {
                                          const data = res.data;
                                          setCandidateDetails(res.data);
                                          setSelectedCandidate(candidate);
                                          setModalType("Hold");
                                          setShowModal(true);
                                        }
                                      } catch (err) {
                                        console.error(err);
                                      }
                                    }}
                                    className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
                                  >
                                    Hold
                                  </button>
                                  <button
                                    onClick={async () => {
                                      try {
                                        setOpenMenu(null);

                                        const res = await GetCandidateDetails(
                                          candidate.submitedCandidateUID,
                                        );

                                        if (res?.data?.status === "Success") {
                                          const data = res.data;
                                          setCandidateDetails(res.data);
                                          setSelectedCandidate(candidate);
                                          setModalType("BGV");
                                          setShowModal(true);
                                        }
                                      } catch (err) {
                                        console.error(err);
                                      }
                                    }}
                                    className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
                                  >
                                    Background Verification
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="py-6 text-red-500 text-center">
                        No Candidate Found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <Pagination
              totalItems={filteredCandidates.length}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </div>
      </div>

      {/* FILTER MODAL */}
     <ColumnFilterModal
        show={!!activeFilter}
        onHide={() => setActiveFilter(null)}
        title={activeFilter}
        items={filterOptions[activeFilter] || []}
        filteredItems={(filterOptions[activeFilter] || []).filter((item) =>
          item?.toLowerCase().includes(filterSearch.toLowerCase()),
        )}
        selectedItems={filters[activeFilter] || []}
        setSelectedItems={(values) =>
          setFilters((prev) => ({
            ...prev,
            [activeFilter]: values,
          }))
        }
        searchText={filterSearch}
        setSearchText={setFilterSearch}
      />

      <CandidateDetailsModal
        show={showModal}
        onClose={() => {
          setShowModal(false);
          setModalType(null);
        }}
        candidateDetails={candidateDetails}
        selectedCandidate={selectedCandidate}
        showInterviewDetailsSection={isInterviewScheduled}
        interviewDetails={interviewDetails}
        modalActionType={modalType}
        remark={remark}
        setRemark={setRemark}
        onActionSubmit={handleAction}
        actionLoading={actionLoading}
        showResumeButton={true}
        showInterviewSection={false}
        onViewResume={() => handleResumeClick(selectedCandidate)}
        showSystemRemarkButton={true}
        showSystemRemark={showSystemRemark}
        systemRemarkData={systemRemarkData}
        onViewSystemRemark={handleViewSystemRemark}
        onScheduleClick={handleScheduleClick}
        onViewFeedback={handleViewFeedback}
        systemRemarkLoading={systemRemarkLoading}
      />

      <SystemRemarkModal
        show={showSystemRemarkModal}
        onClose={() => setShowSystemRemarkModal(false)}
        systemRemarkData={systemRemarkData}
      />

      <ScheduleInterviewModal
        show={showScheduleModal}
        onClose={() => {
          setShowScheduleModal(false);
          setShowModal(true);
        }}
        selectedInterview={selectedInterview}
        interviewDateTime={interviewDateTime}
        setInterviewDateTime={setInterviewDateTime}
        remark={remark}
        setRemark={setRemark}
        onSchedule={handleSchedule}
      />

      <InterviewFeedbackModal
        show={showFeedbackModal}
        onClose={() => {
          setShowFeedbackModal(false);
          setShowModal(true);
        }}
        feedbackData={feedbackData}
      />

      <ViewResumeModal
        show={showResumeModal}
        onClose={() => {
          setShowResumeModal(false);
        }}
        resumeUrl={resumeUrl}
      />

      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default RejectedCandidates;
